<template>
    <div>
        <page-header :title="$t('master.membershipUpgrade')" />
        <div class="membership-text">
            <p class="header-text ion-text-start">{{ $t('plans.headerParagraph') }}</p>

            <ion-grid class="plans ion-text-start ion-margin-start ion-margin-end">
                <ion-row>
                    <ion-col
                        class="plan plan-one selected ion-padding-end"
                        @click="selectPlan(1)"
                        size="6"
                        :style="selectedPlan === 1 && ' background-color: #dfd1b0;'"
                    >
                        <h4 color="primary">{{ $t('plans.firstPlanTitle') }}</h4>
                        <p>{{ $t('plans.firstPlanP1') }}</p>
                        <p>{{ $t('plans.firstPlanP2') }}</p>
                        <p class="price ion-text-center">{{ $t('plans.firstPlanPrice') }}</p>
                    </ion-col>

                    <ion-col
                        class="plan plan-two ion-padding-start"
                        @click="selectPlan(2)"
                        size="6"
                        :style="selectedPlan === 2 && ' background-color: #dfd1b0;'"
                    >
                        <h4>{{ $t('plans.secondPlanTitle') }}</h4>
                        <p>{{ $t('plans.secondPlanP1') }}</p>
                        <p>{{ $t('plans.secondPlanP2') }}</p>
                        <p class="price ion-text-center">{{ $t('plans.secondPlanPrice') }}</p>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <ion-button class="activate-btn" @click="goToPayments">{{ $t('plans.activate') }}</ion-button>
        </div>
        <ad-leaderboard />
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AdLeaderboard from '@/components/AdLeaderboard'
import { constants } from '../constants'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'Plans',
    components: { PageHeader, AdLeaderboard },
    data() {
        return {
            constants,
            selectedPlan: 1,
            isMobile
        }
    },
    methods: {
        selectPlan: function(plan) {
            this.selectedPlan = plan
        },
        goToPayments: function() {
            this.$router.push(`/payments?plan=${this.selectedPlan}`)
        }
    }
}
</script>

<style lang="scss" scoped>
.membership-text {
    background-color: #f5f5f5;

    .header-text {
        padding: 15px 20px;
        font-size: 13px;
    }
    .plans {
        background-color: #ffffff;

        .plan {
            h4 {
                font-size: 18px;
                color: #114f64;
            }

            p {
                margin: 5px 0;
                border-bottom: 1px solid;
                padding-bottom: 3px;
                font-size: 12px;
                color: #141414;

                &.price {
                    color: #188665;
                    border: none;
                }
            }
        }
    }

    ion-button {
        margin: 24px 0;
        --border-radius: 40px;
    }
}

.banner {
    margin: 20px 10px;
}
@media (min-width: 768px) {
    .header-text {
        font-size: 20px !important;
    }

    ion-grid {
        width: 90%;
        margin: 0 5%;

        ion-col {
            padding: 20px 25px;

            p {
                margin: 15px 0 !important;
                font-size: 15px !important ;
            }

            h4 {
                font-size: 22px !important;
            }
        }
    }

    .activate-btn {
        font-size: 20px;
        width: 30%;
        --border-radius: 40px;
    }
}
@media (min-width: 1200px) {
    .header-text {
        background: transparent;
    }
}
</style>
